import type { BadgeTone } from '@/components/ui/badge'
import type { BordroDurum, CalismaTuru, OdemeDurum, PersonelDurum } from '../types'

export function personelDurumTone(d: PersonelDurum): BadgeTone {
  if (d === 'aktif') return 'success'
  if (d === 'izinli') return 'warning'
  return 'info'
}

export function calismaTuruLabelKey(t: CalismaTuru): string {
  return `hr.personel.calisma.${t}`
}

export function bordroDurumTone(d: BordroDurum): BadgeTone {
  if (d === 'onay') return 'success'
  if (d === 'kontrol') return 'info'
  return 'neutral'
}

export function odemeDurumTone(d: OdemeDurum): BadgeTone {
  if (d === 'odendi') return 'success'
  if (d === 'planlandi') return 'info'
  return 'warning'
}
